const AUTH_RETURN_TARGET_KEY = "xm_auth_return_target";

export const getCurrentRelativeUrl = (): string =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const sanitizeAuthReturnTarget = (target: string | null): string | null => {
  if (!target) return null;
  const normalizedTarget = [...target]
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code > 31 && code !== 127;
    })
    .join("");
  if (!normalizedTarget.startsWith("/")) return null;
  const secondChar = normalizedTarget[1];
  if (secondChar === "/" || secondChar === "\\") return null;
  return normalizedTarget;
};

export const buildAuthReturnUrl = (target: string = getCurrentRelativeUrl()): string => {
  const safeTarget = sanitizeAuthReturnTarget(target) || "/";
  sessionStorage.setItem(AUTH_RETURN_TARGET_KEY, safeTarget);
  return `/auth/return?to=${encodeURIComponent(safeTarget)}`;
};

export const consumeAuthReturnTarget = (search: string): string => {
  const searchParams = new URLSearchParams(search);
  const queryTarget = sanitizeAuthReturnTarget(searchParams.get("to"));
  const storedTarget = sanitizeAuthReturnTarget(
    sessionStorage.getItem(AUTH_RETURN_TARGET_KEY),
  );
  sessionStorage.removeItem(AUTH_RETURN_TARGET_KEY);
  return queryTarget || storedTarget || "/";
};
